import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function Incidencias() {
    const [incidents, setIncidents] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/incidents/mine")
            .then((r) => setIncidents(r.data || []))
            .catch(() => toast.error("Error cargando incidencias"))
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="p-6 md:p-10 fade-in min-h-screen max-w-2xl mx-auto">
            <h1 className="text-2xl font-semibold mb-1 inline-flex items-center gap-2"><AlertTriangle size={22} className="text-edu-navy" /> Incidencias</h1>
            <p className="text-edu-muted mb-6">Incidencias registradas por los profesores de tu hijo/a.</p>

            {loading ? (
                <p className="text-sm text-edu-muted">Cargando…</p>
            ) : incidents.length === 0 ? (
                <div className="edu-card p-8 text-center text-edu-muted">Sin incidencias registradas.</div>
            ) : (
                <div className="space-y-3">
                    {incidents.map((i) => (
                        <div key={i.id} className="edu-card p-4">
                            <div className="flex items-center justify-between mb-1">
                                <p className="text-sm font-medium">{i.course_name}</p>
                                <p className="text-xs text-edu-muted">{new Date(i.created_at).toLocaleString("es-PE")}</p>
                            </div>
                            <p className="text-sm text-edu-body">{i.descripcion}</p>
                            <p className="text-xs text-edu-muted mt-1">Registrado por {i.created_by_name}</p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
